// import Vue from "vue";
// import VueRouter from "vue-router";
import { isLogin } from "@/utils/auth";
import buyer from "./buyer";
import seller from "./seller";
import store from "@/store";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject)
    return originalPush.call(this, location, resolve, reject);
  let call = originalPush.call(this, location);
  return call && call.catch(() => {});
};

let routes = buyer.concat(seller);
const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let fullPath = to.fullPath;
  if (
    (fullPath.indexOf("/user") === 0
        || fullPath.indexOf("/seller") === 0)
        && !isLogin()
  ) {
    Cookies.set("redirectPath", fullPath || "");
    return next({ path: "/login" });
  } else {
    // if (store.getters.userInfo.isShopUser && fullPath.indexOf("/user") === 0) {
    //   return next({ path: "/seller" });
    // }
    return next();
  }
});

export default router;
